import {
  Box,
  Fade,
  List,
  ListItem,
  ListItemText,
  Slide,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { userLogout } from '../../redux/actions/user';
import AccountLinks from '../account-links';
import './right-menu-bar.css';

const useStyles = makeStyles((theme: Theme) => ({
  dimPanel: {
    position: 'fixed',
    background: 'rgba(0, 0, 0, 0.5)',
    right: 0,
    width: '100%',
    height: '100vh',
    zIndex: 1101,
    [theme.breakpoints.down('xl')]: {
      display: 'block !important',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    textTransform: 'uppercase',
    padding: '5px 0px',
    '& span': {
      fontSize: '13px !important',
      fontFamily: "'Archivo-ExtraBold' !important",
    },
  },
}));

const MENU_SLIDE_MS = 450;

const RightMenuBar = (props: any) => {
  const { closeDrawer, removeCart, open } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const reduceMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideMs = reduceMotion ? 0 : MENU_SLIDE_MS;
  const logout = () => {
    dispatch(userLogout());
    closeDrawer(false);
    navigate('/login');
  };
  return (
    <>
      <Fade in={!!open} timeout={slideMs} mountOnEnter unmountOnExit>
        <div
          className={classes.dimPanel}
          onClick={() => closeDrawer(false)}
        ></div>
      </Fade>
      <Slide
        in={!!open}
        direction="right"
        timeout={slideMs}
        easing={{
          enter: theme.transitions.easing.easeOut,
          exit: theme.transitions.easing.easeInOut,
        }}
        mountOnEnter
        unmountOnExit
      >
        <Box
          id="expendable-content-3"
          className="list-sec"
          sx={{
            boxShadow: 2,
            bgcolor: 'background.paper',
            height: '100%',
            position: 'fixed',
            overflow: 'auto',
            paddingBottom: '80px',
            width: {
              xs: '100%',
              sm: removeCart ? '150px' : '527px',
              md: removeCart ? '527px' : '527px',
            },
            zIndex: '1102',
            boxSizing: 'border-box',
          }}
        >
          <AccountLinks
            right={true}
            closeDrawer={(value: boolean) => {
              closeDrawer(value);
            }}
          />
        </Box>
      </Slide>
    </>
  );
};

export default RightMenuBar;
